import React from 'react';
import Select from 'components/Core/Select';

const questionList = [
  'What was your childhood nickname?',
  'In what city did you meet your spouse/significant other?',
  'What is the name of your favorite childhood friend?',
  'What street did you live on in third grade?',
  'What is the middle name of your youngest child?',
  "What is your oldest sibling's middle name?",
  'What school did you attend for sixth grade?',
];

const SecurityQuestionSelect = (props) => (
  <Select
    {...props}
    MenuProps={{ PopoverClasses: { paper: 'modal' } }}
    options={questionList.map((x) => ({ label: x, value: x }))}
  />
);

export default SecurityQuestionSelect;
